import React, { FC, PropsWithChildren } from 'react';
import { BrowserRouter as Router, BrowserRouterProps } from 'react-router-dom';
import { App } from '../../components/App';
import { InitialProps } from '../../types';
import { Page } from '../../components/Page';

const TypedRouter = Router as React.ComponentType<PropsWithChildren<BrowserRouterProps>>;

const Main: FC<InitialProps> = (props) => (
  <TypedRouter basename={props.basename}>
    <App {...props}>
      <Page />
    </App>
  </TypedRouter>
);

export default Main;
